import { useContext } from 'react';

import { PendingInvitationsModalContext } from './PendingInvitationsModal.context';

export function usePendingInvitationsModal() {
  const context = useContext(PendingInvitationsModalContext);
  if (context === undefined) {
    throw new Error(
      'usePendingInvitationsModal must be used within a PendingInvitationsModalProvider'
    );
  }
  return context;
}
